<script setup>

import PickStock from "@/components/warehouse/PickStock"
import SlideInDrawer from "@/components/common/navigation/SlideInDrawer";
import Table from "@/components/common/other/Table";
import DocumentUpload from "@/components/common/other/DocumentUpload";

import {inject, ref} from 'vue';

const pickStock = inject("pickStock");
const updateGridRender = ref();

</script>

<template>
  <SlideInDrawer
      :height="395"
      title="Picked Stock"
      v-model:open-drawer="pickStock.openPicksDrawer">
    <div style="margin-top: 30px;">
      <Table
          :key="updateGridRender"
          :allowGridMenu="false"
          height="230"
          :page-size="180"
          :selectable="false"
          :row-selection="false"
          :dataSource="pickStock.pickedItems"
          :columns="pickStock.pickedItemGridColumns">
        <template v-slot:unPick="row">
          <i class="fa-solid fa-rotate-reverse" style="font-size: 18px; color: #a81616; margin-left: 20px"></i>
        </template>
      </Table>
    </div>
  </SlideInDrawer>
  <SlideInDrawer
      :height="320"
      title="Upload Documents"
      v-model:open-drawer="pickStock.openDocsDrawer">
      <DocumentUpload v-model="pickStock"></DocumentUpload>
  </SlideInDrawer>
  <PickStock
      @update-picked-items="updateGridRender = $event"
      v-model="pickStock">
  </PickStock>

</template>

<style scoped>

</style>
